import { useEffect, useState } from "react";
import { Plus, Trash2, Save } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

const inp = "w-full border border-slate-200 rounded-lg px-2.5 py-1.5 text-sm";

const Row = ({ t, onChange }) => {
  const [f, setF] = useState({ name: t.name, subject: t.subject, body: t.body });
  const save = async () => { try { t.id ? await api.put(`/api/mail/templates/${t.id}`, f) : await api.post("/api/mail/templates", f); toast.success("Template saved"); onChange(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async () => { if (!window.confirm(`Delete "${t.name}"?`)) return; await api.delete(`/api/mail/templates/${t.id}`).catch(() => {}); onChange(); };
  return (
    <details className="border border-slate-200 rounded-lg" open={!t.id} data-testid={`tpl-${t.id || "new"}`}>
      <summary className="px-3 py-2 text-sm font-semibold cursor-pointer">{t.name || "New template"}</summary>
      <div className="p-3 pt-0 space-y-2">
        <input value={f.name} onChange={e => setF({ ...f, name: e.target.value })} placeholder="Button name" className={inp} data-testid={`tpl-name-${t.id || "new"}`} />
        <input value={f.subject} onChange={e => setF({ ...f, subject: e.target.value })} placeholder="Subject" className={inp} data-testid={`tpl-subject-${t.id || "new"}`} />
        <textarea rows={5} value={f.body} onChange={e => setF({ ...f, body: e.target.value })} className={inp} data-testid={`tpl-body-${t.id || "new"}`} />
        <div className="flex gap-2"><button onClick={save} className="text-xs font-semibold bg-blue-600 text-white px-3 py-1.5 rounded-lg flex items-center gap-1" data-testid={`tpl-save-${t.id || "new"}`}><Save className="w-3.5 h-3.5" />Save</button>
          {t.id && <button onClick={del} className="text-xs text-red-600 flex items-center gap-1" data-testid={`tpl-delete-${t.id}`}><Trash2 className="w-3.5 h-3.5" />Delete</button>}</div>
      </div>
    </details>
  );
};

/* Admin: inbox alert switches + editable one-tap reply templates. */
export const MailExtras = ({ s, onSaved }) => {
  const [tpl, setTpl] = useState([]);
  const [adding, setAdding] = useState(false);
  const load = () => api.get("/api/mail/templates").then(r => setTpl(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, []);
  const alerts = async (k, v) => { try { await api.put("/api/mail/setup/alerts", { alert_email: s.alert_email, alert_text: s.alert_text, [k]: v }); onSaved(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-4 text-sm" data-testid="mail-alerts">
        <label className="flex items-center gap-1.5"><input type="checkbox" checked={s.alert_email} onChange={e => alerts("alert_email", e.target.checked)} data-testid="mail-alert-email" />Email the rep about new mail</label>
        <label className="flex items-center gap-1.5"><input type="checkbox" checked={s.alert_text} onChange={e => alerts("alert_text", e.target.checked)} data-testid="mail-alert-text" />Text the rep (uses Textbelt credits)</label>
      </div>
      <div className="space-y-1.5" data-testid="mail-templates-admin">
        <p className="text-xs text-slate-500">Reply templates reps can tap. You can use <code className="bg-slate-100 px-1 rounded">{"{first_name} {rep_name} {booking_link} {quote_link} {pricing_link} {demo_link}"}</code></p>
        {tpl.map(t => <Row key={t.id} t={t} onChange={load} />)}
        {adding ? <Row t={{ name: "", subject: "", body: "" }} onChange={() => { setAdding(false); load(); }} /> : <button onClick={() => setAdding(true)} className="text-sm font-semibold text-blue-600 flex items-center gap-1" data-testid="tpl-add-btn"><Plus className="w-4 h-4" />Add template</button>}
      </div>
    </div>
  );
};
